import { Component, h } from 'preact';
import Tock from 'tocktimer';

class Countdown extends Component {
  constructor() {
    super();

    this.state = { timeLeft: null };

    this.onTick = this.onTick.bind(this);
    this.onComplete = this.onComplete.bind(this);

    this.timer = new Tock({
      countdown: true,
      interval: 1000,
      callback: this.onTick,
      complete: this.onComplete,
    });
  }

  onTick() {
    const now = Math.ceil(this.timer.lap() / 1000);

    this.setState({
      timeLeft: now === 0 ? 'Updating!' : now,
    });
  }

  onComplete() {
    if (this.props.onComplete) this.props.onComplete();

    this.timer.start(this.props.duration);
  }

  componentDidMount() {
    this.timer.start(this.props.duration);
  }

  render({}, { timeLeft }) {
    let klass = 'countdown';
    const timeLeftIsNumber = typeof timeLeft === 'number' && isFinite(timeLeft);

    let output = null;

    if (timeLeft === '--') {
      output = `Next update in ${timeLeft}`;
    } else if (timeLeftIsNumber) {
      output = `Next update in :${timeLeft}`;
    } else if (timeLeft === 'Updating!') {
      output = timeLeft;
    } else {
      output = null;
    }

    return <p className={klass}>{output}</p>;
  }
}

Countdown.defaultProps = {
  duration: 30 * 1000,
};

export default Countdown;



// WEBPACK FOOTER //
// ./components/Countdown.js